import templateUrl from './edit-team-modal.component.html'

export const EditTeamModalComponent = {
    controller: EditTeamModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    },
    templateUrl
}

function EditTeamModalController($q, employeeService, roleService, teamService, utilityService) {
    'ngInject'
    const vm = this;
    vm.$onInit = onInit;
    vm.onChangeRole = onChangeRole;
    vm.onChangeTeamMembers = onChangeTeamMembers;
    vm.onSave = onSave;

    function onInit() {
        vm.team = {
            Roles: [],
            TeamMembers: [],
            ...vm.resolve.team
        }
        const teamDetailsLoaded = retrieveEmployeesInTeam()
            .then(function (employees) {
                vm.team.TeamMembers.forEach(function (teamMember) {
                    const employee = employees.filter(function (employee) {
                        return employee.Id === teamMember.EmployeeID;
                    })[0];
                    if (employee) {
                        teamMember.FullName = (employee.FirstName || "") + " " + (employee.LastName || "");
                    }
                })
            });
        const rolesLoaded = roleService.retrieveRoles()
            .then(function (roles) {
                vm.roles = roles.filter(function (roles) {
                    // Only office roles can be assigned to teams.
                    return roles.IsOfficeRole;
                }).map(function (role) {
                    return {
                        RoleID: role.Id,
                        Name: role.Name,
                        Description: role.Description,
                        IsInRole: vm.team.Roles.filter(function (roleID) {
                            return roleID === role.Id;
                        }).length > 0
                    };
                });
            });
        const initialDataLoaded = $q.all([teamDetailsLoaded, rolesLoaded]);

        initialDataLoaded.then(function () {
            // Assign options once initial data has finished loading.
            vm.teamMemberMultiSelectOptions = createTeamMemberMultiSelectOptions();
        });

        utilityService.showLoadingUntilResolved(initialDataLoaded);
    }

    function onChangeRole(role) {
        if (role.IsInRole) {
            vm.team.Roles.push(role.RoleID);
        } else {
            vm.team.Roles = vm.team.Roles.filter(function (roleID) {
                return role.RoleID !== roleID;
            });
        }
    }

    function onChangeTeamMembers() {
        // Validate team member validation:
        // Must be at least one team leader.
        const enoughTeamLeaders = vm.team.TeamMembers.reduce(function (any, teamMember) {
            return any || teamMember.Leader;
        }, false);
        if (vm.editForm) {
            vm.editForm.$setValidity("enoughTeamLeaders", enoughTeamLeaders)
        }
    }

    function onSave() {
        const request = {
            Name: vm.team.Name,
            Notes: vm.team.Notes,
            Roles: vm.team.Roles,
            TeamMembers: vm.team.TeamMembers
        };
        let teamSaved;
        if (vm.team.TeamID) {
            request.TeamID = vm.team.TeamID;
            teamSaved = teamService.updateTeam(vm.team.TeamID, request);
        } else {
            // Can only set corporation when initially creating team.
            request.IcdCorporationID = vm.team.IcdCorporationID;
            teamSaved = teamService.createTeam(request);
        }

        teamSaved.then(function (team) {
            vm.close({ $value: team });
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(teamSaved, "Saving failed"));
    }

    /**
     * Create options for a team member multi-select based on the current team.
     */
    function createTeamMemberMultiSelectOptions() {
        const dataSource = {
            transport: {
                read: function (options) {
                    const currentSelection = $q.when(vm.team.TeamMembers);
                    // Load both selected team members and the first page of search results based on the filter.
                    const filters = {};
                    if (options.data.filter && options.data.filter.filters) {
                        if (options.data.filter.filters[0]) {
                            filters.FullName = options.data.filter.filters[0].value;
                        }
                    }
                    const searchResults = employeeService.retrieveEmployees({
                        FullName: filters.FullName,
                        PageIndex: options.data.pageIndex,
                        PageSize: options.data.pageSize,
                        IsGlobal: !vm.team.IcdCorporationID
                    }).then(function (employees) {
                        return employees.map(function (employee) {
                            return {
                                EmployeeID: employee.Id,
                                FullName: (employee.FirstName || "") + " " + (employee.LastName || ""),
                                Leader: false
                            };
                        });
                    });
                    $q.all([currentSelection, searchResults])
                        .then(function (v) {
                            let res = [];
                            if (!filters.FullName) {
                                res = res.concat(v[0]);
                            }
                            return res.concat(v[1]);
                        })
                        .then(function (employees) {
                            options.success(employees);
                        })
                        .catch(function (ex) {
                            options.error(ex);
                        });
                }
            },
            serverFiltering: true,
            serverPaging: true,
            pageSize: 30
        };
        return {
            dataSource: dataSource,
            filter: "contains",
            autoClose: false
        }
    }

    function retrieveEmployeesInTeam() {
        const fullTeamMembers = vm.team.TeamMembers.map(function (member) {
            return member.EmployeeID;
        });

        return employeeService.retrieveEmployees({
            EmployeeIDs: fullTeamMembers
        });
    }
}
